import { ActionIcon, Box, Flex, useMantineTheme, Title } from "@mantine/core";
import { memo } from "react";
import { CardRadius } from "src/utils/constants";
import Offerings from "./Offerings";
import { MdContentCopy } from "react-icons/md";
import { handleCopyClick } from "src/utils/utils";

type IWebIntegration = {
  orgId: string;
  locId: string;
};

function WebIntegration({ orgId, locId }: IWebIntegration) {
  const integrationUrl = `${window.location.host}/${locId}/memberships/${orgId}`;
  const theme = useMantineTheme();

  let border = `1px solid ${theme.colors.primary[6]}`;
  let bg = theme.colors.primary[6];
  let color =
    theme.colorScheme === "light"
      ? theme.colors.primaryTextColor[6]
      : theme.colors.light[1];

  return (
    <>
      <Flex
        sx={{ border, borderRadius: CardRadius.md }}
        bg={bg}
        justify={"space-between"}
        p={"xs"}
      >
        <Title order={5} color={color}>
          Integration URL: {integrationUrl}
        </Title>
        <ActionIcon onClick={() => handleCopyClick(integrationUrl)}>
          <MdContentCopy size={18} />
        </ActionIcon>
      </Flex>
      <Box mt={"sm"} mb={"xs"}>
        <Offerings locId={locId} />
      </Box>
    </>
  );
}

export default memo(WebIntegration);
